import { render, staticRenderFns } from "./ActivityPremiumsTable.vue?vue&type=template&id=6080a026&scoped=true"
import script from "./ActivityPremiumsTable.vue?vue&type=script&lang=js"
export * from "./ActivityPremiumsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6080a026",
  null
  
)

export default component.exports